module.exports = __webpack_public_path__ + "img/copy.db05cfa1.svg";